import { render } from "./modal.vue?vue&type=template&id=16d4b43d"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/lego/plugin/modal/modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16d4b43d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16d4b43d', __exports__)) {
    api.reload('16d4b43d', __exports__)
  }
  
  module.hot.accept("./modal.vue?vue&type=template&id=16d4b43d", () => {
    api.rerender('16d4b43d', render)
  })

}


export default __exports__